export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const CLEAR_COMPANY_INPUT_VALUE = "CLEAR_COMPANY_INPUT_VALUE";
export const CLEAR_LEGAL_INPUT_VALUE = "CLEAR_LEGAL_INPUT_VALUE";
//保存企业类型
export const SAVE_COMPANY_TYPE = "SAVE_COMPANY_TYPE";
//更新邀请码是否展示逻辑
export const UPDATE_INVITATION_CODE_SHOW = "UPDATE_INVITATION_CODE_SHOW";
//填充邀请码
export const FILL_INVITATION_CODE = "FILL_INVITATION_CODE";
export const FILL_COMPANY_TYPE = "FILL_COMPANY_TYPE";
//识别企业营业执照
export const ANALYZE_COMPANY_LICENSE = "ANALYZE_COMPANY_LICENSE";
//识别企业营业执照后填充企业信息
export const FILL_COMPANY_INFO = "FILL_COMPANY_INFO";
//保存企业信息
export const SAVE_COMPANY_LICENSE = "SAVE_COMPANY_LICENSE";
//识别用户身份证
export const ANALYZE_USER_LICENSE = "ANALYZE_USER_LICENSE";
//识别用户身份证后填充法人信息
export const FILL_LEGAL_INFO = "FILL_LEGAL_INFO";
//保存法人信息
export const SAVE_USER_LICENSE = "SAVE_USER_LICENSE";
//填充品类信息
export const FILL_QUALIFY_INFO = "FILL_QUALIFY_INFO";
//获取一级品类
export const LOAD_FIRST_CATES = "LOAD_FIRST_CATES";
//获取子品类
export const LOAD_SUB_CATES = "LOAD_SUB_CATES";
//保存资质并且提交审核
export const SAVE_DETAIL = "SAVE_DETAIL";
//获取当前注册信息
export const GET_REGISTER_INFO = "GET_REGISTER_INFO";
//设置当前注册信息
// export const SET_REGISTER_INFO = "SET_REGISTER_INFO";
//获取个人中心信息
// export const GET_PERSONAL_INFO = "GET_PERSONAL_INFO";
//设置个人中心信息
export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
//退出当前账号
// export const QUIT_ACCOUNT = "QUIT_ACCOUNT";
// 实时校验统一社会信用代码
export const VALIDATE_CODE = "VALIDATE_CODE";




// WEBPACK FOOTER //
// ./src/store/register/type.js